<template>
	<div class="container">
		<div class="jiangli_top">
			<img @click="$router.go(-1)" src="../../assets/images/licai/fanhui.png" />
			<p class="">{{ $t('m.kf_span0') }}</p>
		</div>
		<iframe id="iframe" style="border:none;margin-top:45px;" :src="reportUrl" :width="searchTableWidth"></iframe>
		<div style="height: 50px;"></div>
	</div>
</template>
<script>
import $store from '../../store';
import request from '@utils/request';
import { getCustomerServiceLink } from '@api/user';
export default {
	name: '',
	data() {
		return {
			reportUrl: '',
			searchTableHeight: 0,
			searchTableWidth: 0
		};
	},
	mounted() {
		request.get('/shop/sign/status', {}, { login: true });
		this.searchTableHeight = window.innerHeight;
		this.searchTableWidth = window.innerWidth;
		this.loadCustomerService();
	},
	created() {
		// this.reportUrl = this.$storage.get('kf_url')
	},
	watch: {
		$route: function() {
			// 监听路由变化
			//   this.reportUrl =  this.$storage.get('kf_url')
		}
	},
	methods: {
		loadCustomerService() {
			getCustomerServiceLink({ _t: Date.now() })
				.then(res => {
					const kf = res && res.data ? res.data.data : '';
					this.contract(kf || $store.state.app.kf);
				})
				.catch(() => {
					this.contract($store.state.app.kf);
				});
		},
		contract(kf) {
			if (!kf) {
				return;
			}
			console.log('客服地址：' + kf);
			$store.commit('SET_KF', kf);
			this.reportUrl = kf;
		},
		onClickLeft() {
			this.$router.go(-1);
		}
	},
	components: {}
};
</script>

<style scoped lang="less">
iframe {
	height: calc(~'84vh - 50px');
}
.jiangli_top {
	width: 100%;
	height: 45px;
	line-height: 45px;
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	box-sizing: border-box;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: #fff;
}
.jiangli_top img {
	height: 30px;
	width: 30px;
	position: absolute;
	left: 0px;
}
.jiangli_top p {
	font-size: 18px;
	font-family: Microsoft YaHei;
	font-weight: 400;
	color: #333333;
	text-align: center;
}
</style>

